'use strict';

/* ---------------------------------------------
PRODUCT SWIPER
------------------------------------------------ */

/*Slider function [It is recommended to place a function in a separate JS file, such as "functions.js"]*/

function productSlider() {
    $('#full-product-list').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                infinite: true,
                dots: true
            }
        }, {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        }, {
            breakpoint: 769,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        }, {
            breakpoint: 581,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    });
}

// SHOW RANDOM QUOTE ON LOAD
function randomNumber(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

const home = {
    init: function () {

        productSlider();

        /* ---------------------------------------------
        HOME QUOTES SLICK
        ------------------------------------------------ */
        if ($('.swiper-container-quotes').length > 0) {
            $('.swiper-container-quotes .swiper-wrapper').slick({
                arrows: true,
                centerMode: true,
                centerPadding: '60px',
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: true,
                autoplay:false,
                speed:500,
                prevArrow: '<div class="swiper-btn-prev" tabindex="0" role="button" aria-label="Reveal previous slide"><div class="de-hide-mobile"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow" viewBox="0 0 111 65"><g fill="none" fill-rule="evenodd" stroke="#fb48c4"><path d="M111 32.5H1M33 65L1 32.998 33 1"></path></g></svg></div><div class="de-show-mobile"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-mobile" viewBox="0 0 26 26"><g fill="none" fill-rule="evenodd" stroke="#FB48C4" stroke-width=".512"><path d="M25.171 12.499l-24.893.035M12.706 25.212L.278 12.728 12.706.246"></path></g></svg></div></div>',
                nextArrow: '<div class="swiper-btn-next" tabindex="0" role="button" aria-label="Reveal next slide"><div class="de-hide-mobile"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow" viewBox="0 0 111 65"><g fill="none" fill-rule="evenodd" stroke="#fb48c4"><path d="M111 32.5H1M33 65L1 32.998 33 1"></path></g></svg></div><div class="de-show-mobile"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-mobile" viewBox="0 0 26 26"><g fill="none" fill-rule="evenodd" stroke="#FB48C4" stroke-width=".512"><path d="M25.171 12.499l-24.893.035M12.706 25.212L.278 12.728 12.706.246"></path></g></svg></div></div>',
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    }
                ]
            })
        }   

        //Click event on love slider carousel
        $(document).on('keypress','.swiper-container-quotes .swiper-btn-next , .swiper-container-quotes .swiper-btn-prev', function(e){
            if(e.which === 13){
                $(this).trigger('click');
            }
        })

        /* ---------------------------------------------
        HOME QUOTE
        ------------------------------------------------ */
        var footerOffsetTop = $('.de-site-footer').offset().top;

        $(window).on('resize', function () {
            footerOffsetTop = $('.de-site-footer').offset().top;
        });

        $(window).on('scroll', function () {
            var windowTotalScrollTop = $(window).innerHeight() + $(window).scrollTop();
            if (windowTotalScrollTop > footerOffsetTop) {
                var sideOffset = footerOffsetTop - windowTotalScrollTop;
                $('.js-quote').css('top', sideOffset + 166);
            } else {
                $('.js-quote').css('top', 166);
            }
        });

        var upperLimit = $('.js-quote span').length - 1;
        var randomNo = randomNumber(0, upperLimit);
        $('.js-quote span').eq(randomNo).show();
    }
}

export default home;